import {Injectable} from "@angular/core";
import {HttpObservable} from "../../http/services/http.wrapper";
import {ConfProxy} from "../../http/services";

@Injectable()
export class ThemeProxy {
	constructor(private httpWrapper: ConfProxy) {

	}

	public getPatientPortalDynamicThemeVariables(): HttpObservable<any> {
		return this.httpWrapper.getAnon("PatientPortalTheme", "GetTheme");
	}
}
